'use strict';

var FaresOptimizerOptionaModalDirective = function FaresOptimizerOptionaModalDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/fares-optimizer-options-modal.html'),
    controller: 'FaresOptimizerOptionsModalController',
    link: function link($scope, $element) {
      $scope.$watch('screenState.showOptionsModal', function (newVal) {
        if (newVal) {
          $element.modal('show');
          $scope.screenState.showOptionsModal = false;
        }
      });
    }
  };
};
FaresOptimizerOptionaModalDirective.$inject = [];
module.exports = FaresOptimizerOptionaModalDirective;